import React from 'react';

export const CourseContext = React.createContext();

export const CourseProvider = CourseContext.Provider;
